const DATABASE_NAME = 'expospace-local-content';
const LEGACY_DATABASE_NAME = 'baechisil-local-content';
const DATABASE_VERSION = 1;
const STORE_NAME = 'view-files';

function openDatabase(databaseName = DATABASE_NAME) {
  return new Promise<IDBDatabase>((resolve, reject) => {
    const request = indexedDB.open(databaseName, DATABASE_VERSION);
    request.onupgradeneeded = () => {
      const database = request.result;
      if (!database.objectStoreNames.contains(STORE_NAME)) database.createObjectStore(STORE_NAME);
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error ?? new Error('로컬 콘텐츠 저장소를 열지 못했습니다.'));
  });
}

export async function saveLocalViewFile(file: File) {
  const database = await openDatabase();
  const key = crypto.randomUUID();
  await new Promise<void>((resolve, reject) => {
    const transaction = database.transaction(STORE_NAME, 'readwrite');
    transaction.objectStore(STORE_NAME).put(file, key);
    transaction.oncomplete = () => resolve();
    transaction.onerror = () => reject(transaction.error ?? new Error('파일을 로컬에 저장하지 못했습니다.'));
  });
  database.close();
  return key;
}

export async function readLocalViewFile(key: string) {
  const database = await openDatabase();
  const file = await new Promise<Blob | null>((resolve, reject) => {
    const transaction = database.transaction(STORE_NAME, 'readonly');
    const request = transaction.objectStore(STORE_NAME).get(key);
    request.onsuccess = () => resolve(request.result instanceof Blob ? request.result : null);
    request.onerror = () => reject(request.error ?? new Error('로컬 파일을 읽지 못했습니다.'));
  });
  database.close();
  if (file) return file;

  const legacyDatabase = await openDatabase(LEGACY_DATABASE_NAME);
  const legacyFile = await new Promise<Blob | null>((resolve, reject) => {
    const transaction = legacyDatabase.transaction(STORE_NAME, 'readonly');
    const request = transaction.objectStore(STORE_NAME).get(key);
    request.onsuccess = () => resolve(request.result instanceof Blob ? request.result : null);
    request.onerror = () => reject(request.error ?? new Error('기존 로컬 파일을 읽지 못했습니다.'));
  });
  legacyDatabase.close();
  return legacyFile;
}

export async function deleteLocalViewFile(key: string) {
  const database = await openDatabase();
  await new Promise<void>((resolve, reject) => {
    const transaction = database.transaction(STORE_NAME, 'readwrite');
    transaction.objectStore(STORE_NAME).delete(key);
    transaction.oncomplete = () => resolve();
    transaction.onerror = () => reject(transaction.error ?? new Error('로컬 파일을 삭제하지 못했습니다.'));
  });
  database.close();
}
